import request from '@/utils/request';

export interface TrendDataPoint {
  label: string;
  value: number;
}

export interface DashboardVO {
  totalTokenUsage: number;
  todayTokenUsage: number;
  onlineUsers: number;
  newUsersToday: number;
  newUsersThisWeek: number;
  newUsersThisMonth: number;
  pendingPostCount: number;
  pendingCommentCount: number;
  pendingReportCount: number;
  totalUsers: number;
  totalPosts: number;
  totalComments: number;
  tokenTrendDaily: TrendDataPoint[];
  tokenTrendWeekly: TrendDataPoint[];
  tokenTrendMonthly: TrendDataPoint[];
  newUserTrendDaily: TrendDataPoint[];
  newUserTrendWeekly: TrendDataPoint[];
  newUserTrendMonthly: TrendDataPoint[];
}

/**
 * 获取管理端首页统计数据
 */
export const getAdminDashboardStats = () => {
  return request({
    url: '/admin/dashboard/statistics',
    method: 'get'
  });
};